export const SET_PROGRAM = "SET_PROGRAM";
export const SET_PROGRAMS = "SET_PROGRAMS";
export const SET_SUGGESTED_PROGRAMS = "SET_SUGGESTED_PROGRAMS";

export const SET_PROGRAM_WORKOUTS = "SET_PROGRAM_WORKOUTS";
